import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { Await } from '@oysterjs/ui/async';

import type { EmailTemplateListFieldsFragment } from '~/api/graphql';
import { LibraryListLoading } from '~/components/list/library-list-loading';
import { EmailTemplatesList } from '~/components/email-templates/email-templates-list';

type EmailTemplatesLoaderData = {
  data: Promise<{ emailTemplates: EmailTemplateListFieldsFragment[] }>;
};

export const LibraryEmailTemplatesPage = () => {
  const loaderData = useLoaderData() as EmailTemplatesLoaderData;

  return (
    <React.Suspense fallback={<LibraryListLoading title="Loading email templates…" />}>
      <Await resolve={loaderData.data}>
        {({ emailTemplates }) => <EmailTemplatesList emailTemplates={emailTemplates} />}
      </Await>
    </React.Suspense>
  );
};
